// export const API_URL = 'https://localhost:44395/api';
// export const API_URL = 'https://mh-api-test.illustrativedna.com/api';
export const API_URL = 'https://mhapi.illustrativedna.com/api';